module.exports = __webpack_public_path__ + "img/bg16.8117020a.png";